/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateEmailsWithFVSDto
 */
export interface CreateUpdateEmailsWithFVSDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailsWithFVSDto
     */
    companyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateEmailsWithFVSDto
     */
    selectedInvoices?: Array<string>;
}

/**
 * Check if a given object implements the CreateUpdateEmailsWithFVSDto interface.
 */
export function instanceOfCreateUpdateEmailsWithFVSDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateUpdateEmailsWithFVSDtoFromJSON(json: any): CreateUpdateEmailsWithFVSDto {
    return CreateUpdateEmailsWithFVSDtoFromJSONTyped(json, false);
}

export function CreateUpdateEmailsWithFVSDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateEmailsWithFVSDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'selectedInvoices': !exists(json, 'selectedInvoices') ? undefined : json['selectedInvoices'],
    };
}

export function CreateUpdateEmailsWithFVSDtoToJSON(value?: CreateUpdateEmailsWithFVSDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'selectedInvoices': value.selectedInvoices,
    };
}

